import { useEffect, useMemo } from 'react';
import L from 'leaflet';
import { useLeaflet } from 'react-leaflet';
import PropTypes from 'prop-types';

function EdgeBufferTileLayer({ buffer, ...props }) {
  const { map } = useLeaflet();
  const { url } = props;

  const tileLayer = useMemo(() => {
    return L.tileLayer(url, { ...props, buffer });
  }, [buffer, props, url]);

  useEffect(() => {
    if (map && !map.hasLayer(tileLayer)) {
      map.addLayer(tileLayer);
    }

    return () => {
      if (map && map.hasLayer(tileLayer)) {
        map.removeLayer(tileLayer);
      }
    };
  }, [map, tileLayer]);

  return null;
}

EdgeBufferTileLayer.propTypes = {
  /** The number of pixels beyond the
   * visible area of the map to preload tiles for. A higher buffer value
   * will preload more tiles, making panning smoother at the cost of
   * increased initial loading time and memory usage. */
  buffer: PropTypes.number,
  /** The URL template for the tile server. */
  url: PropTypes.string.isRequired,
};

EdgeBufferTileLayer.defaultProps = {
  buffer: 512,
};

export default EdgeBufferTileLayer;
